// Return true if passed an empty object, false otherwise
export default obj => obj && typeof obj === 'object' && Object.keys(obj).length === 0;
